/**
 * Numero con decimales. Cubre `float` y `decimal`.
 *
 * Los `decimal` se emiten como string: el backend los serializa asi para no
 * perder precision, y devolverlos convertidos a `number` reintroduciria
 * exactamente el error de redondeo que esa decision evita.
 */

import { controlClass } from '@/components/fields/controls';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import { fraccionDe, stepFor, useNumericBuffer } from '@/components/fields/numeric';
import type { FieldInputProps } from '@/components/fields/types';

export function FloatField({
  id,
  meta,
  value,
  onChange,
  readonly,
  required,
  invalid,
  describedBy,
}: FieldInputProps) {
  // Un `float` no fuerza ceros: `3` se ve "3", no "3,000000". minFraccion 0 y
  // maxFraccion en la precision declarada recortan la cola de ceros.
  const buffer = useNumericBuffer(value, onChange, {
    entero: false,
    decimal: meta.type === 'decimal',
    minFraccion: 0,
    maxFraccion: fraccionDe(meta),
  });

  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  return (
    <input
      id={id}
      type="text"
      inputMode="decimal"
      data-step={stepFor(meta)}
      className={controlClass(invalid, 'text-right tabular-nums')}
      value={buffer.texto}
      required={required}
      aria-required={required || undefined}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      autoComplete="off"
      onFocus={buffer.alEntrar}
      onChange={(evento) => {
        buffer.alEscribir(evento.target.value);
      }}
      onBlur={buffer.alSalir}
    />
  );
}
